export default __webpack_public_path__ + "static/media/Link.83d058f5.svg";